// Values are the visible radio labels from the retired Recurly radio payment form. They are kept as
// the toggle's value type because TogglePaymentButton still switches between Apple Pay and card.
export enum PaymentOptionValues {
  Apple = 'Apple Pay',
  CreditCard = 'Credit card'
}
